<template lang="html">
  <div class="col-md-12">
    <p v-if="duration >= 0 && endToNow >= 0" class="help-block">
      <span v-if="startToNow >= 0">
        {{ $t('marker.activation_time_help', {
           at: start.locale(locale).fromNow(),
           duration: readableDuration(duration, locale)
         }) }}
      </span>
      <span v-else>
        {{ $t('marker.activation_immediate_help', {
           duration: readableDuration(endToNow, locale)
         }) }}
      </span>
    </p>
    <p v-else-if="duration < 0" class="help-block error">
      {{ $t('marker.invalid_duration')}}
    </p>
    <p v-else-if="endToNow < 0" class="help-block error">
      {{ $t('marker.invalid_end_time')}}
    </p>
  </div>
</template>

<script>
// Duration helper component
// Tell the user when the marker will activate (e.g. 'This event will activate
// in 2 days and last for 15 minutes.') in a <p> tag.

import moment from 'moment'

export default {
  props: ['start', 'end'],
  data () {
    return {
      now: Date.now()
    }
  },
  mounted () {
    this.interval = setInterval(() => {
      this.now = Date.now()
    }, 1000)
  },
  methods: {
    readableDuration: function (t, locale) {
      return moment.duration(t).locale(locale).humanize()
    }
  },
  computed: {
    startToNow () {
      return this.start - this.now
    },
    endToNow () {
      return this.end - this.now
    },
    locale () {
      return this.$i18n.locale
    },
    duration () {
      return this.end - this.start
    }
  },
  destroyed () {
    clearInterval(this.interval)
  }
}
</script>



// WEBPACK FOOTER //
// DurationHelper.vue?1cae0225